import Icon from '../components/Icon.vue'

Icon.register({"window-close":{"width":1792,"height":1792,"paths":[{"d":"M1175 1321l146-146q10-10 10-23t-10-23l-233-233 233-233q10-10 10-23t-10-23l-146-146q-10-10-23-10t-23 10l-233 233-233-233q-10-10-23-10t-23 10l-146 146q-10 10-10 23t10 23l233 233-233 233q-10 10-10 23t10 23l146 146q10 10 23 10t23-10l233-233 233 233q10 10 23 10t23-10zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/window-close.js
// module id = LwaB
// module chunks = 1